import Header from "components/Common/Header/Header";
import TemperatureBody from "components/PatientManagement/Vital/Temperature/TemperatureBody";
import React, { useEffect } from "react";

const Temperature = () => {
  useEffect(() => {
    document.title = "Vitals | Temperature";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <TemperatureBody />
    </main>
  );
};

export default Temperature;
